"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const molecules_1 = require("../../molecules");
const utils_1 = require("../../utils");
function SelectNotifications({ onClick, className, nextAction, notificationsExtraData, }) {
    const hasSelected = notificationsExtraData &&
        !!(0, utils_1.getSelectedNotificationIDs)(notificationsExtraData).length;
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'SelectNotifications_Container', children: [(0, jsx_runtime_1.jsx)(molecules_1.SelectAllNotifications, { className: className, nextAction: nextAction, onClick: onClick, "data-e2e": 'SelectNotifications_SelectAllNotifications' }), hasSelected && ((0, jsx_runtime_1.jsx)(molecules_1.ClearButton, { clearAll: true, className: className, title: i18n_1.Strings.settings.notifications.clearAll, notificationsExtraData: notificationsExtraData, "data-e2e": 'SelectNotifications_ClearButton' }))] }));
}
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  height: 40px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 48px;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    margin-left: 35px;
    border-left: 5px solid ${({ theme }) => theme.designSystem.background};
  `)};
`;
exports.default = SelectNotifications;
